<template>
  <div>
    <div class="w-100 row justify-content-end align-items-center mb-2">
      <b-button
        class="align-items-center font-weight-regular"
        :class="showDownloadOptions ? null : 'collapsed'"
        size="sm"
        id="downloads-options"
        variant="success"
        :aria-expanded="showDownloadOptions ? 'true' : 'false'"
        aria-controls="collapse-downloads"
        @click="showDownloadOptions = !showDownloadOptions"
      >
        Baixar Planilha
      </b-button>
    </div>

    <b-collapse
      id="collapse-downloads"
      v-model="showDownloadOptions"
      class="mt-1 download-options"
    >
    <download-table-content
      :downloadCSV="downloadCSV"
      :downloadXLSX="downloadXLSX"
      :downloadPDF="downloadPDF"
      :show-json="false"
      class="py-2 py-lg-2"
    />
    </b-collapse>
    <data-table
      ref="dataTable"
      sticky-header
      class="flex-grow-1"
      max-height-table="70vh"
      :left-frozen-columns="leftFrozenColumns"
      :static-columns="staticColumns"
      :table-data="tableData"
      :file-prefix="`Manejo diário`"
      />

  </div>
</template>

<script>
import DataTable from "@/pages/components/shared/table/DataTable.vue";
import DownloadTableContent from "@/pages/components/shared/table/DownloadTableContent.vue";
import table from "@/mixins/table";
import { calcPercentageRounded } from "@/pages/components/helpers";


export default {
  name: "report-management-daily",
  mixins: [table],
  components: {
    DownloadTableContent,
    DataTable,
  },
  props: {
    tableData: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showDownloadOptions: false,
      leftFrozenColumns: [
        {
          title: "Nome do setor",
          field: "SECTOR_NAME",
          minWidth: 130,
          maxWidth: 130
        },
      ],
      staticColumns: [
        {
          title: "NDC",
          field: "NDC",
          minWidth: 90,
          width: 90
        },
        {
          title: "Cultivar",
          field: "FARM_NAME",
          minWidth: 200,
          maxWidth: 200,
          formatter: (cell) => {
            const cellValue = cell.getValue();
            const maxLength = 20;
            this.decimalFormatter(cell.getValue());
            
            if(cellValue.length > maxLength) {
              return `${cellValue.slice(0,maxLength)}...`
            }

            return cellValue;
          },
        },
        {
          title: "Armazenamento inicial (mm)",
          field: "INITIAL_STORAGE",
          minWidth: 150,
          maxWidth: 150,
          accessorDownload: (val) => this.decimalFormatter(val),
        },
        {
          title: "Armazenamento final (mm)",
          field: "FINAL_STORAGE",
          minWidth: 150,
          maxWidth: 150,
          accessorDownload: (val) => this.decimalFormatter(val),
        },
        {
          title: "Disponibilidade de água (%)",
          field: "WATER_DISPONIBILITY",
          minWidth: 200,
          maxWidth: 300,
          tooltip: cell => {
            return (
              `Água disponível: ${this.calcPercentageRounded(cell.getData().FINAL_STORAGE, cell.getData().MAX_STORAGE)}% (${cell.getData().FINAL_STORAGE}mm)`+
              `\npara armazenamento máximo de: ${cell.getData().MAX_STORAGE}mm`
            )
          },
          formatter:(cell) => {
            const storagePercentage = this.calcPercentageRounded(cell.getData().FINAL_STORAGE, cell.getData().MAX_STORAGE);
            const availability = (1 - cell.getData().AVAILABILITY) * 100;

            let bgColor = 'bg-';

            if(storagePercentage <= availability) {
              bgColor += 'danger';
            } else if(storagePercentage <= ((100 - availability)/2 + availability)) {
              bgColor += 'warning'
            } else {
              bgColor += '3v3';
            }

            return `
              <div
                data-max="100"
                data-min="0"
                class="${bgColor}"
                style="display: inline-block;
                position: relative;
                width: ${storagePercentage}%;
                height: 100%;" >
              </div>`
                // return "<span style='color:#3FB449; font-weighst:bold;'>" + value + "</span>";
          },
          accessorDownload: (val, rowData) => {
            return this.calcPercentageRounded(rowData.FINAL_STORAGE, rowData.MAX_STORAGE)
          },
          hozAlign: "start",
        },
        {
          title: "Excedente previsto (mm)",
          field: "EXCESS",
          formatter: (cell) => this.decimalFormatter(cell.getValue()),
        },
        {
          title: "Agenda aplicada",
          field: "IRRIGATED_BLADE_INFOS",
          minWidth: 250,
          // maxWidth: 250
        },
        {
          title: "Agenda sugerida",
          field: "BLADE_SUGGESTION_INFOS",
          minWidth: 250,
          // maxWidth: 250
        },
        {
          title: "Usuário",
          field: "EDITOR_NAME",
          minWidth: 250,
          formatter: (cell) => {
            const editor = cell.getValue();

            const fieldVal = editor ? editor : "-";

            return `
              <span
                class="${editor? "font-weight-bold" : ""}"
              >
                ${fieldVal}
              </span>
            `;
          },
          accessorDownload: (val, row) => {
            const editorNameFieldVal = !!row.EDITOR_NAME;
            return editorNameFieldVal ? val : '-'
          },
          // maxWidth: 250
        },
        // {
        //   title: "Profundidade de raiz (cm)",
        //   field: "DEPTH_ROOT"
        // },
        // {
        //   title: "Projeção de rama (m)",
        //   field: "BRANCH"
        // },
      ],
    }
  },
  methods: {
    calcPercentageRounded,
    downloadCSV() {
      return this.$refs.dataTable.downloadCSV();
    },
    downloadXLSX() {
      return this.$refs.dataTable.downloadXLSX();
    },
    downloadPDF() {
      return this.$refs.dataTable.downloadPDF();
    },
  },
  mounted() {
    window.onclick = (event)=> {
       if (event.target.id != "collapse-downloads" && event.target.id!="downloads-options" && this.showDownloadOptions) {
          this.showDownloadOptions=false
       }
    }
  }
}
</script>
<style scoped>
.users-table {
  height: 310px !important;
  overflow-x: hidden;
  overflow-y: auto;
}
.download-options{
  position: absolute;
  background: white;
  padding: 5px;
  right: 0;
  margin: 0 10px;
  z-index: 99;
  min-width: 10em;
  max-width:15em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.1s cubic-bezier(.25,.8,.25,1);
  border-radius: 4px;
}
</style>
